import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RiMenu3Line } from 'react-icons/ri';
import logo from '../../image/logo.png';

const MyNavbar = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`lp-navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="lp-navbar-inner">
        <a href="#accueil" className="lp-navbar-brand" onClick={closeMenu}>
          <img src={logo} alt="Easy Compta" />
        </a>

        <button
          type="button"
          className="lp-nav-toggle"
          aria-label="Menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <RiMenu3Line />
        </button>

        <div className={`lp-mobile-menu ${menuOpen ? 'open' : ''}`}>
          <ul className="lp-nav-links">
            <li>
              <a href="#fonctionnalites" onClick={closeMenu}>
                Fonctionnalités
              </a>
            </li>
            <li>
              <a href="#avantages" onClick={closeMenu}>
                Avantages
              </a>
            </li>
            <li>
              <a href="#temoignages" onClick={closeMenu}>
                Témoignages
              </a>
            </li>
          </ul>
          <div className="lp-nav-actions">
            <button
              type="button"
              className="lp-btn lp-btn-outline"
              onClick={() => {
                closeMenu();
                navigate('/login');
              }}
            >
              Connexion
            </button>
            <button
              type="button"
              className="lp-btn lp-btn-primary"
              onClick={() => {
                closeMenu();
                navigate('/signup');
              }}
            >
              Essayer gratuitement
            </button>
          </div>
        </div>

        <ul className="lp-nav-links">
          <li>
            <a href="#fonctionnalites">Fonctionnalités</a>
          </li>
          <li>
            <a href="#avantages">Avantages</a>
          </li>
          <li>
            <a href="#temoignages">Témoignages</a>
          </li>
        </ul>

        <div className="lp-nav-actions">
          <button
            type="button"
            className="lp-btn lp-btn-outline"
            onClick={() => navigate('/login')}
          >
            Connexion
          </button>
          <button
            type="button"
            className="lp-btn lp-btn-primary"
            onClick={() => navigate('/signup')}
          >
            Essayer gratuitement
          </button>
        </div>
      </div>
    </nav>
  );
};

export default MyNavbar;
